import React, {useState, useEffect} from 'react'
import cn from "classnames"
import pageBg from '../../img/start-page-bg.webp'
import mapTrack from '../../img/line-map.png'
import {Preloader, SideParameters, SpriteSvg} from '../../components'

import tuman from "../../img/tuman.png";
import sun2 from "../../img/sun2.png";
import sun3 from "../../img/sun3.png";
import sun4 from "../../img/sun4.png";
import sun5 from "../../img/sun5.png";
import sun6 from "../../img/sun6.png";
import {useMousePosition} from "../../utils";

const MapPage = ({
	handleNextPage,
	name,
	isLoaded,
	setIsLoaded,
	isRouteTraveled,
	gameEnded,

	startPage,
	trainPage,
	trainStationPage,
	meadowPage,
	afterMeadowGamePage,
	mapPage,
	backpackPage,
	waterfallPage,
	afterWaterfallGamePage,
	trailPage,
	afterTrailGamePage,
	peaksPage,
	afterPeaksGamePage,
	campPage,
	afterCampGamePage,
	mountainPage,
	afterMountainGamePage,
	finalPage,
}) => {

	const [isVisibleContent, setIsVisibleContent] = useState(false)

	useEffect(()=> {
		setTimeout(()=> {
			setIsVisibleContent(true)
		},5000)
	},[])

	const position = useMousePosition()

	const game0Link =
		!isRouteTraveled.includes(afterMeadowGamePage)
			? meadowPage
			: afterMeadowGamePage

	const game1Link =
		!isRouteTraveled.includes(afterWaterfallGamePage)
		? waterfallPage
		: afterWaterfallGamePage

	const game2Link =
		!isRouteTraveled.includes(afterTrailGamePage)
			? trailPage
			: afterTrailGamePage

	const game3Link =
		!isRouteTraveled.includes(afterPeaksGamePage)
			? peaksPage
			: afterPeaksGamePage

	const game4Link =
		!isRouteTraveled.includes(afterCampGamePage)
			? campPage
			: afterCampGamePage

	const game5Link =
		!isRouteTraveled.includes(afterMountainGamePage)
			? mountainPage
			: afterMountainGamePage

	console.log('gameEnded', gameEnded)
	console.log('isRouteTraveled', isRouteTraveled)
	return (
		<>
			<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>

			<div className={cn(
				'full-page',
				'map-page',
				isLoaded && 'active'
			)}
			>
				{gameEnded(isRouteTraveled) === 6 &&
					<SideParameters
						knowledge={4} skill={4} exp={4} dexterity={4} strong={4}
					/>
				}
				{gameEnded(isRouteTraveled) === 5 &&
					<SideParameters
						knowledge={4} skill={4} exp={4} dexterity={4} strong={4}
					/>
				}
				{gameEnded(isRouteTraveled) === 4 &&
				<SideParameters
					knowledge={4} skill={4} exp={3} dexterity={3} strong={2}
				/>
				}
				{gameEnded(isRouteTraveled) === 3 &&
					<SideParameters
						knowledge={3} skill={3} exp={3} dexterity={3} strong={2}
					/>
				}
				{gameEnded(isRouteTraveled) === 2 &&
					<SideParameters
						knowledge={2} skill={3} exp={3} dexterity={2} strong={1}
					/>
				}
				{gameEnded(isRouteTraveled) === 1 &&
					<SideParameters
						knowledge={2} skill={2} exp={2} dexterity={1} strong={1}
					/>
				}

				<div className="page-bg right-sun">
					<img className='bg-img' src={pageBg} alt=""/>
					<img className='smoke-img' style={{transform: `translate(-${position.x / 100}px, -${position.y / 75}px)`}} src={tuman} alt=""/>
					<img className='sun2' style={{transform: `translate(-${position.x / 10}px, -${position.y / 10}px)`}} src={sun2} alt=""/>
					<img className='sun3' style={{transform: `translate(-${position.x / 25}px, -${position.y / 25}px)`}} src={sun3} alt=""/>
					<img className='sun4' style={{transform: `translate(-${position.x / 50}px, -${position.y / 50}px)`}} src={sun4} alt=""/>
					<img className='sun5'  src={sun5} alt=""/>
					<img className='sun6' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px)`}} src={sun6} alt=""/>
				</div>

				<div className={cn(
					'page-content',
					isVisibleContent &&
					'active'
				)}>


					<div className={cn(
						'content',
						'center',
					)}>
						<div className="map-wrap">
							<div className={cn(
								'map-Link',
								'link-1',
								 'active'
							)}>
								<div className="title">
									<p>Поляна</p>
								</div>
								<div className="dot">
									<div onClick={()=> handleNextPage(game0Link)} className="map-btn">
										{isRouteTraveled.includes(trainStationPage) && !isRouteTraveled.includes(afterMeadowGamePage)
											? <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-active'/>
											: <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-finished'/>
										}
										<SpriteSvg className='lock' width='40px' height='40px' id='map-icon-disabled'/>
									</div>
								</div>
							</div>

							<div className={cn(
								'map-Link',
								'link-2',
								isRouteTraveled.includes(afterMeadowGamePage) && 'active'
							)}>
								<div className="title">
									<p>Горный водопад</p>
								</div>
								<div className="dot">
									<div onClick={()=> handleNextPage(game1Link)} className="map-btn">
										{isRouteTraveled.includes(afterMeadowGamePage) && !isRouteTraveled.includes(afterWaterfallGamePage)
										? <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-active'/>
										: <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-finished'/>
										}
										<SpriteSvg className='lock' width='40px' height='40px' id='map-icon-disabled'/>
									</div>
								</div>
							</div>

							<div className={cn(
								'map-Link',
								'link-3',
								isRouteTraveled.includes(afterWaterfallGamePage) && 'active'
							)}>
								<div className="title">
									<p>Тропа</p>
								</div>
								<div className="dot">
									<div onClick={()=> handleNextPage(game2Link)} className="map-btn">
										{isRouteTraveled.includes(afterWaterfallGamePage) && !isRouteTraveled.includes(afterTrailGamePage)
											? <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-active'/>
											: <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-finished'/>
										}
										<SpriteSvg className='lock' width='40px' height='40px' id='map-icon-disabled'/>
									</div>
								</div>
							</div>

							<div className={cn(
								'map-Link',
								'link-4',
								isRouteTraveled.includes(afterTrailGamePage) && 'active'
							)}>
								<div className="title">
									<p>Скалы</p>
								</div>
								<div className="dot">
									<div onClick={()=> handleNextPage(game3Link)} className="map-btn">
										{isRouteTraveled.includes(afterTrailGamePage) && !isRouteTraveled.includes(afterPeaksGamePage)
											? <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-active'/>
											: <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-finished'/>
										}
										<SpriteSvg className='lock' width='40px' height='40px' id='map-icon-disabled'/>
									</div>
								</div>
							</div>

							<div className={cn(
								'map-Link',
								'link-5',
								isRouteTraveled.includes(afterPeaksGamePage) && 'active'
							)}>
								<div className="title">
									<p>Перевалочный лагерь</p>
								</div>
								<div className="dot">
									<div onClick={()=> handleNextPage(game4Link)} className="map-btn">
										{isRouteTraveled.includes(afterPeaksGamePage) && !isRouteTraveled.includes(afterCampGamePage)
											? <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-active'/>
											: <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-finished'/>
										}
										<SpriteSvg className='lock' width='40px' height='40px' id='map-icon-disabled'/>
									</div>
								</div>
							</div>

							<div className={cn(
								'map-Link',
								'link-6',
								isRouteTraveled.includes(afterCampGamePage) && 'active'
							)}>
								<div className="title">
									<p>Горное седло</p>
								</div>
								<div className="dot">
									<div onClick={()=> handleNextPage(game5Link)} className="map-btn">
										{isRouteTraveled.includes(afterCampGamePage) && !isRouteTraveled.includes(afterMountainGamePage)
											? <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-active'/>
											: <SpriteSvg className='circle' width='40px' height='40px' id='map-icon-finished'/>
										}
										<SpriteSvg className='lock' width='40px' height='40px' id='map-icon-disabled'/>
									</div>
								</div>
							</div>

							<div className="map-track-wrap">
								<img className='mountain' src={mapTrack} alt=""/>
							</div>
						</div>


					</div>

				</div>

			</div>
		</>
	)
}

export default MapPage